import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './ContentCard.css';


const ContentCard = (props) => {
  const {
    children,
    className,
    contentClass,
    footer,
    footerClass,
    headerClass,
    title,
  } = props;

  const containerClasses = classNames(styles.container, className);
  const titleClasses = classNames(styles.title, headerClass);
  const contentClasses = classNames(styles.content, contentClass);
  const footerClasses = classNames(styles.footer, footerClass);

  return (
    <div className={containerClasses}>
      {title && (
        <div className={titleClasses}>
          {title}
        </div>
      )}
      <div className={contentClasses}>
        {children}
      </div>
      {footer && (
        <div className={footerClasses}>
          {footer}
        </div>
      )}
    </div>
  );
};

ContentCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentClass: PropTypes.string,
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),
  footerClass: PropTypes.string,
  headerClass: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

ContentCard.defaultProps = {
  children: null,
  className: undefined,
  contentClass: undefined,
  footer: null,
  footerClass: undefined,
  headerClass: undefined,
  title: null,
};

export default ContentCard;
